import React from "react";
import Card from "../card";
import Banner from "../../pages/banner";
import "./product.css";

const ProductPage = ({ title, subtitle, bannerImage, products }) => {
  return (
    <>
      <Banner title={title} subtitle={subtitle} image={bannerImage} />

      <div className="product-section">
        <h1 className="product-title">{title}</h1>

        <div className="product-grid">
          {products.map((item) => (
            <Card
              key={item.id}
              id={item.id}
              image={item.image}
              title={item.title}
              description={item.description}
            />
          ))}
        </div>
      </div>
    </>
  );
};

export default ProductPage;